// extracted by mini-css-extract-plugin
module.exports = {"root":"Data_root__18GE-"};